// extracted by mini-css-extract-plugin
export default {"oldQrRedirectContainer":"style_oldQrRedirectContainer__uGhn9"};